import { API_TEMPLATE_UPDATE } from "api/email";
import { API_SINGLE_ElEMENT } from "api/email";
import HtmlEditor from "components/HtmlEditor/HtmlEditor";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";

function UpdateEmailTemplate() {
  const [jsonData, setJsonData] = useState("");
  const [jsonError, setJsonError] = React.useState("");
  const [json, setJson] = useState("");
  const [jsonDataError, setJsonDataError] = useState("");
  const [isDesignSaved, setIsDesignSaved] = useState(0);
  const [data, setData] = useState("");
  const [subject, setSubject] = useState('');
  const navigate = useNavigate();
  const [html, setHtml] = useState("");
  const { id } = useParams();
  const {t} = useTranslation();
  console.log(id, "iddsdsdssds");
  const getJsonData = (data) => {
    console.log(data,'jsonDataaaa')
    setJsonData(data);
  };
  const getHtml = (data) => {
    console.log(data, "asdfsdlafhlasdkj");
    setHtml(data);
  };
  const getUpdatedJsonData = (data) => {
    setJsonData(data);
  };

  const handleSaveDesign = () => {
    setIsDesignSaved(1);
  };

  const fetch = async (id) => {
    const payload = {
      id: id,
    };
    const res = await API_SINGLE_ElEMENT(payload);
    if (res) {
      console.log(res, "dataaas");
      setData(res?.data);
      setJsonData(res?.data?.template?.body_json)
      setHtml(res?.data?.template?.body)
      setSubject(res?.data?.template?.subject)
    }
  };
  const handleUpdateTemplate = async () => {
    try {
      const payload = {
        id: id,
        update_all: true,
        slug: "order_placed",
        template: {
          subject: subject,
          body: html,
          body_json:jsonData,
          fields:["{{order_id}}","{{order_status}}"]
        },
      };
      const res = await API_TEMPLATE_UPDATE(payload);
      if (res) {
        console.log(res);
        navigate('/admin/email/list-email-template')
      }
    } catch (err) {}
  };

  // data?.template?.body
  useEffect(() => {
    if (id) {
      fetch(id);
    }
  }, [id]);
  return (
    <div className="flex min-w-[100%] flex-col gap-5 rounded-2xl border-[1px] bg-white p-12  shadow-md">
      <div className="mb-10 flex w-full flex-row items-center gap-10">
        <div className="flex w-full flex-col gap-2">
          <label className="font-bold">{t("Subject")}</label>
          <input
            className="mt-2 flex h-11 w-full items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none"
            placeholder="Template name"
            value={subject}
            onChange={(e) => setSubject(e.target.value)}
          />
        </div>
      </div>
      <div className="rounded-[10px] border-[1px]">
        <HtmlEditor
          json={data?.template?.body_json}
          updatedJsonData={getUpdatedJsonData}
          jsonError={jsonDataError}
          handleSaveDesign={handleSaveDesign}
          getHtml={getHtml}
          getJsonData = {getJsonData}
        />
      </div>
      <div
        onClick={handleUpdateTemplate}
        className="linear p-[4px 11px] ml-auto  mt-8 flex w-full max-w-[9rem] cursor-pointer items-center justify-center rounded-xl bg-brand-500 py-2 text-center text-base font-medium text-white transition duration-200 hover:bg-white  hover:text-brand-500 dark:bg-brand-400 dark:text-white dark:active:bg-brand-200"
      >
        {t("Update template")}
      </div>
    </div>
  );
}

export default UpdateEmailTemplate;
